/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VolumeStatisticComplianceDto } from './volumeStatisticComplianceDto';

/**
 * Volume statistic compliance data for one requested period
 */
export interface PeriodVolumeStatisticComplianceDto {
  /**
   * Requested from time
   */
  fromTime: string;
  /**
   * Requested to time
   */
  toTime: string;
  statistics: Array<VolumeStatisticComplianceDto>;
}
